/**
* DevExpress Dashboard (_card-layout.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { floatFromModel, itemType, nullableFloatToModel } from '../../../metadata/_base-metadata';
export let templateId = { propertyName: 'templateID', modelName: '@TemplateID' };
export let minWidth = { propertyName: 'minWidth', modelName: '@MinWidth', displayName: 'DashboardWebStringId.CardLayout.MinWidth', defaultVal: 200, from: floatFromModel };
export let maxWidth = { propertyName: 'maxWidth', modelName: '@MaxWidth', displayName: 'DashboardWebStringId.CardLayout.MaxWidth', defaultVal: NaN, from: floatFromModel, toJsonObject: nullableFloatToModel };
export let cardRows = { propertyName: 'rows', modelName: 'CardRows', array: true };
export let cardLayoutSerializationInfo = [itemType, minWidth, maxWidth, cardRows];
